import { FETCH_DCM_PLACEMENTS } from "./constants";
import { SUCCESS, FAILURE, PENDING } from "../constants";

import { fetchPlacementsService } from "../../services/dcm/placements";
import { setAuthError } from "../app/global";

const beginFetchDcmPlacements = (campaignId) => ({
  type: FETCH_DCM_PLACEMENTS,
  status: PENDING,
  campaignId
});

const successDcmPlacements = placements => ({
  type: FETCH_DCM_PLACEMENTS,
  status: SUCCESS,
  data: placements
});

const failureDcmPlacements = err => ({
  type: FETCH_DCM_PLACEMENTS,
  status: FAILURE,
  err
});

export const fetchDcmPlacements = (campaignId) => {
  return async dispatch => {
    dispatch(beginFetchDcmPlacements());

    let response;

    try {
      response = await fetchPlacementsService(campaignId);

      dispatch(successDcmPlacements(response));
    } catch (e) {
      if (e.message === "UNAUTHORIZED") {
        dispatch(setAuthError());
        return;
      }

      dispatch(failureDcmPlacements(e));
    }
  };
};
